import { apiClient } from "shared/api/client";

/** 관리자/소통 페이지 상단 공지(adminNotice) 도메인 API. */
export const getAdminNotice = async () => {
  const response = await apiClient.get("/adminNotice");
  return response.data;
};

export const updateAdminNotice = async (content) => {
  await apiClient.patch("/adminNotice", { content });
};
